export default "__VITE_ASSET__84Iuraef__"